import React, { useEffect } from 'react';
import type { SingleCommonType } from '../../types';
import { commonBackInfo } from '../../utils';
import { gameAffinityPlaceholder } from '../../constants/placeholder';
import { useCompareRangeDefaultValue } from '../../hooks/init';
import { useIntl } from 'umi';
import CustomThanRange from '../../components/CustomThanRange';
import { FILTER_CONST } from '../../constants';
import BubbleCommon, {
  gameAffinityFilterTips,
} from '@op/components/BubbleCommon';
import { FilterButtonPoint } from '@op/operationLog/pages/filter';

const errorText = 'The input data cannot exceed 100%';
export default function GameAffinitySelect({
  onChange,
  defaultValue,
  filterValue,
  defaultKey,
  oriDefaultFilter,
  backOriDefaultValue,
  lang,
}: SingleCommonType) {
  const { compareRef, rangeValue, setRangeValue, diffClassName } =
    useCompareRangeDefaultValue({
      defaultValue,
      filterValue,
      oriDefaultFilter,
      backOriDefaultValue,
      defaultKey: 'game_affinitys',
      valueKey: 'affinity',
      dealwithValueFunc: (value: string) => {
        const v = Number(value);
        return isNaN(v) ? '0' : String(v * 100);
      },
    });
  const { formatMessage } = useIntl();
  useEffect(() => {
    const showHeader = compareRef.current?.buttonElement?.(rangeValue);
    const data = [];
    const { start, end, sign } = rangeValue;
    const value: any = {
      end_affinity: Number(end) / 100,
      sign,
    };

    if (!sign) {
      value.start_affinity = Number(start) / 100;
    }

    data.push(value);

    onChange?.(
      'gameAffinitys',
      commonBackInfo({ game_affinitys: data }, { gameAffinitys: showHeader }),
    );
  }, [rangeValue, formatMessage]);

  function verifyValueFunc({
    start,
    end,
    sign,
  }: {
    start: string;
    end: string;
    sign: string;
  }) {
    const endFlag = Number(end) > 100;
    const startFlag = Number(start) > 100;

    const errorTipsText = endFlag ? errorText : '';
    if (sign === FILTER_CONST.THAN_RANGE_CUSTOMIZE) {
      return {
        startErrorText: '',
        endErrorText: errorTipsText,
        flag: endFlag,
      };
    }

    return {
      startErrorText: startFlag ? errorText : '',
      endErrorText: errorTipsText,
      flag: startFlag || endFlag,
    };
  }

  return (
    <BubbleCommon
      placement="top"
      tipsMap={gameAffinityFilterTips}
      showIcon={false}
    >
      <div className={`dbo-affinity-select ${diffClassName}`}>
        <CustomThanRange
          lang={lang}
          ref={compareRef}
          setRangeValue={setRangeValue}
          rangeValue={rangeValue}
          placeholder={gameAffinityPlaceholder}
          unit="%"
          verifyFunc={verifyValueFunc}
          pointKey={FilterButtonPoint.gameAffinitys}
        ></CustomThanRange>
      </div>
    </BubbleCommon>
  );
}
